// Lets the axios interceptor (outside React) tell AuthContext that the session
// has expired, so React state and localStorage stay in sync and only one
// cleanup+redirect happens even if several requests 401 at the same time.
let sessionExpiredHandler = null;

export function setSessionExpiredHandler(handler) {
  sessionExpiredHandler = handler;
}

export function notifySessionExpired() {
  if (sessionExpiredHandler) {
    sessionExpiredHandler();
  }
}
